export default "__VITE_ASSET__bd092bd7__"